import isEqual from 'lodash/isEqual';
import { createSelector } from 'reselect';
const isPristine = (state) => isEqual(state.elevioIntegration, state.pristineElevioIntegration);
const selectSettings = (state) => state.messengerSettings;
const knowledgeStateSelector = (state) => (Object.assign(Object.assign({}, state), { isPristine: isPristine(state) }));
export const selectKnowledgeState = createSelector([selectSettings], knowledgeStateSelector);
